export type ReviewMethodRequestType = 'Standard' | 'DesignLive';

export type ReviewMethodReply =
    | { requestType: 'Standard' }
    | { requestType: 'DesignLive'; appointmentTime: string };

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * Parses a review-method user reply.
 *
 * Wire format (matching the legacy completionFor payload):
 *   Standard:   { requestType: 'Standard' }
 *   DesignLive: { requestType: 'DesignLive', appointmentTime: <serialized JSON> }
 *
 * Accepts `unknown` input and returns a validated `ReviewMethodReply` or `null` on any
 * validation failure. Lenient on unknown fields.
 *
 * @param data - The input to parse (expected to be the user message data)
 * @returns A validated `ReviewMethodReply` object, or `null` if validation fails
 */
export function parseReviewMethodReply(data: unknown): ReviewMethodReply | null {
    if (!isRecord(data)) {
        return null;
    }

    const { requestType, appointmentTime } = data;

    if (requestType === 'Standard') {
        return { requestType: 'Standard' };
    }

    if (requestType === 'DesignLive') {
        if (typeof appointmentTime !== 'string' || appointmentTime === '') {
            return null;
        }
        return { requestType: 'DesignLive', appointmentTime };
    }

    return null;
}
